document.addEventListener("DOMContentLoaded", function () {


    menuDevelop ();

    /*=============================================>>>>>
  = Fixed menu =
  ===============================================>>>>>*/
    function fixedMenu() {
        let navbar = document.getElementById("main-nav");
        if (window.scrollY >= 100) {
            navbar.classList.add("scrolled");
        } else {
            navbar.classList.remove("scrolled");
        }
    }
    document.addEventListener("scroll", () => {
        fixedMenu();
    });


// Appel de la gestion de cookies RGPD
    let cookies = document.querySelector(".cookies");
    if (cookies) {
        cookies.addEventListener("click", function (e) {
            e.preventDefault();
            if (tarteaucitron) {
                tarteaucitron.userInterface.openPanel();
            }
        });
    }

    /*=============================================>>>>>
  = Topbut =
  ===============================================>>>>>*/
    let btn = document.querySelector("#topbut");
    if (btn != null) {
        window.addEventListener("scroll", function () {
            if (window.scrollY > 300) {
                btn.classList.add("visible");
            } else {
                btn.classList.remove("visible");
            }
        });
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector("html").scrollTop = 0;
            document.querySelector("body").scrollTop = 0;
        });
    }



    let myModal = document.getElementById('myModal');
    let closeButton = document.querySelector('.btn-close-modal');
    if (closeButton != null ) {
        closeButton.addEventListener('click', function () {
            if (myModal) {
                myModal.classList.add('no-visible');
            }
        });
    }
    let fileUpload = document.getElementById('file_upload');
    if (fileUpload) {
        fileUpload.addEventListener('change', function () {
            let fileName = '';
            fileName = this.value;
            document.getElementById('file-selected').innerHTML = fileName.replace(/^.*\\/, "");
        });
    }



});


//Understrap > 1.0 Multi Level
// Module SEO (ne pas oublier de mettre la classe "nos-zones" dans l'item du menu
function menuDevelop () {
    jQuery(".nos-zones .dropdown-toggle").on("click", function(t) {

        t.preventDefault();
        t.stopPropagation();
        jQuery(this).next().hasClass("show") || jQuery(this).parents(".dropdown-menu").first().find(".show").removeClass("show");
        jQuery(this).siblings().toggleClass("show");

        jQuery(this).parents("li.nav-item.dropdown.show").on("hidden.bs.dropdown", function(t) {
            jQuery(".dropdown-menu .show").removeClass("show");
            jQuery(".dropdown-submenu .show").removeClass("show");
        })
    })
}